









































































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import Web from "@/modules/integration/components/Web.vue";
import Android from "@/modules/integration/components/Android.vue";

const Integration = namespace("integration");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Integration",
    };
  },
  components: {
    web: Web,
    android: Android,
  },
})
export default class IntegrationPage extends Vue {
  @Integration.Action("fetchCredentials") fetchCredentials!: () => Promise<{}>;
  @Integration.Getter("getPublicKey") publicKey;
  @Integration.Getter("getSecretKey") secretKey;
  currentExample = "web";

  beforeMount() {
    this.fetchCredentials().catch((err) => console.log(err));
  }
}
